import { makeStyles } from '@material-ui/core/styles';

export const useSharedStyles = makeStyles(() => ({
  clusterRoleChip: {
    marginLeft: 6,
    fontSize: '0.65rem',
    height: 18,
  },
}));
